require("./footer")
require('./cookies')
require('./slim-lang')